import { IconProps, NocIconGenerator } from '../common';

export const Business = (props: IconProps): JSX.Element => (
    <NocIconGenerator
        {...props}
        css={{
            '& path': {
                strokeWidth: '1.2 !important',
            },
        }}
        createIconProps={{
            displayName: 'Business',
            path: (
                <path
                    d="M8.30799 6.6V5.88C8.30799 4.287 8.30799 3 11.2616 3H12.7384C15.692 3 15.692 4.287 15.692 5.88V6.6M13.846 13.818C13.846 13.809 13.846 13.809 13.846 13.8V12.9C13.846 12 13.846 12 12.923 12H11.077C10.154 12 10.154 12 10.154 12.9V13.827M13.846 13.818C13.846 14.799 13.8368 15.6 12 15.6C10.1725 15.6 10.154 14.808 10.154 13.827M13.846 13.818C16.3382 13.512 18.7749 12.612 20.907 11.1M10.154 13.827C7.76343 13.566 5.41901 12.729 3.34226 11.343M8.30799 21H15.692C19.4025 21 20.067 19.551 20.2608 17.787L20.9531 10.587C21.2024 8.391 20.5562 6.6 16.6151 6.6H7.385C3.44378 6.6 2.79768 8.391 3.04689 10.587L3.73914 17.787C3.93297 19.551 4.59753 21 8.30799 21Z"
                    stroke="#212121"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            ),
        }}
    />
);
